define(['angular', '../../filters/text', 'jquery'], function (angular) {
    return angular
        .module('settingsModels', ['textFilters'])
        .factory('SettingsModel', [
            '$filter',
            function ($filter) {
                var SettingsModel = function (settings) {
                    if (typeof settings == 'undefined' || !settings) {
                        settings = {};
                    }

                    if (
                        !settings.options ||
                        settings.options.constructor === Array
                    ) {
                        // Make sure options is an object, not an array
                        settings.options = {};
                    }

                    settings.addPropertyType = function () {
                        var thisSettings = this;

                        var newType = {
                            frontEnd: '',
                            backEnd: '',
                        };
                        thisSettings.propertyTypes.push(newType);
                    };

                    settings.removePropertyType = function (propertyType) {
                        var thisSettings = this;

                        var i = thisSettings.propertyTypes.indexOf(
                            propertyType
                        );
                        if (i > -1) {
                            thisSettings.propertyTypes.splice(i, 1);
                        }
                    };

                    settings.addDynamicCity = function () {
                        var thisSettings = this;

                        var newCity = {
                            name: '',
                            phone: '',
                        };
                        thisSettings.dynamicCities.push(newCity);
                    };

                    settings.removeDynamicCity = function (dynamicCity) {
                        var thisSettings = this;

                        var i = thisSettings.dynamicCities.indexOf(dynamicCity);
                        if (i > -1) {
                            thisSettings.dynamicCities.splice(i, 1);
                        }
                    };

                    settings.save = function (callback) {
                        var thisSettings = this;

                        var request = thisSettings.$update();

                        request.then(function (data) {
                            thisSettings.updateData(data);
                            if (typeof callback == 'function') {
                                callback();
                            }
                        });
                        return request;
                    };

                    settings.updateData = function (data) {
                        var thisSettings = this;

                        if (data) {
                            for (var key in data) {
                                this[key] = data[key];
                            }
                        }
                    };
                    settings.updateData(settings);

                    return settings;
                };
                return SettingsModel;
            },
        ]);
});
